interface SeatImportSummary {
  created: number
  updated: number
  unchanged: number
  removed: number
  error: number
}

const headers: Record<keyof SeatImportSummary, string> = {
  created: 'x-import-created',
  updated: 'x-import-updated',
  unchanged: 'x-import-unchanged',
  removed: 'x-import-removed',
  error: 'x-import-error',
}

const labels: Record<keyof SeatImportSummary, string> = {
  created: 'criada(s)',
  updated: 'atualizada(s)',
  unchanged: 'inalterada(s)',
  removed: 'removida(s)',
  error: 'com erro',
}

/**
 * Columns of the seat import file: the required ones, then the optional `label`.
 */
const seatImportColumns = ['sector_id', 'section', 'row', 'row_order', 'name', 'position', 'type', 'label']

/**
 * Reads the per-status line counts the API sends back as `X-Import-*` headers.
 */
const readSeatImportSummary = (responseHeaders: Record<string, unknown>): SeatImportSummary => {
  const count = (header: string) => {
    const value = responseHeaders[header]

    return typeof value === 'string' || typeof value === 'number' ? Number.parseInt(String(value), 10) || 0 : 0
  }

  return {
    created: count(headers.created),
    updated: count(headers.updated),
    unchanged: count(headers.unchanged),
    removed: count(headers.removed),
    error: count(headers.error),
  }
}

const describeSeatImportSummary = (summary: SeatImportSummary): string => {
  const parts = (Object.keys(labels) as (keyof SeatImportSummary)[])
    .filter(status => summary[status] > 0)
    .map(status => `${summary[status]} ${labels[status]}`)

  return parts.length > 0 ? `${parts.join(', ')}.` : 'Nenhuma linha processada.'
}

/**
 * A blank seat import file, holding only the header row.
 */
const seatImportTemplate = (): string => `${seatImportColumns.join(',')}\n`

export { readSeatImportSummary, describeSeatImportSummary, seatImportTemplate, type SeatImportSummary }
